import { useState, ReactNode } from 'react';
import { Box, Tooltip } from '@mui/material';
import Iconify from '../iconify';
import { Stack } from '@mui/system';

type CopyableTextProps = {
    value: string;
    tooltipTitle: ReactNode;
    children: ReactNode;
};

export function CopyableText({ value, tooltipTitle, children }: CopyableTextProps) {
    const [copied, setCopied] = useState(false);

    const handleCopy = (e: React.MouseEvent) => {
        e.stopPropagation();
        navigator.clipboard.writeText(value || '');
        setCopied(true);
        setTimeout(() => setCopied(false), 1500);
    };

    return (
        <Tooltip
            title={
                <Stack direction='row' spacing={0.5} alignItems='center' onClick={handleCopy} sx={{ display: 'inline-flex', cursor: 'pointer' }}>
                    {tooltipTitle}
                    <Iconify icon={copied ? 'mdi:check' : 'mdi:content-copy'} width={12} height={12} />
                </Stack>
            }
            disableHoverListener={!value}
        >
            <Box
                sx={{
                    maxWidth: '100%',
                    display: 'inline-flex',
                    cursor: 'pointer',
                }}
            >
                {children}
            </Box>
        </Tooltip>
    );
};
